import Signal from 'libs/signals';

const edoPerformanceSignal = Signal({
  fundingPrograms: [],
  platforms: [],
  dropdownFilters: {},
  sort: null,
});
export default edoPerformanceSignal;
